import { defineStore } from "pinia";
import { ElNotification } from "element-plus";
import { getTokenExp } from "@/utils/jwt";
import { emptyUserData, type UserData } from "@/api/user";

const AUTH_KEY = "Authorization";
const EXP_KEY = "Exp";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    authorization: localStorage.getItem(AUTH_KEY) || "",
    exp: localStorage.getItem(EXP_KEY) || "",
    user: emptyUserData()
  }),
  getters: {
    /** 有未过期 token 才算登录中 */
    isLoggedIn: (state) => {
      if (!state.authorization) return false;
      if (!state.exp) return true;
      const expSec = Number(state.exp);
      if (!Number.isFinite(expSec) || expSec <= 0) return true;
      return expSec * 1000 > Date.now();
    },
    displayName: (state) => state.user.name
  },
  actions: {
    setUser(user: UserData) {
      this.user = user;
    },
    setAuthorization(authorization: string) {
      const exp = authorization ? getTokenExp(authorization) : "";
      this.authorization = authorization;
      this.exp = exp;
      localStorage.setItem(AUTH_KEY, authorization);
      localStorage.setItem(EXP_KEY, exp);
    },
    loginSuccess(user: UserData, authorization?: string | null) {
      this.setUser(user);
      if (authorization) {
        this.setAuthorization(authorization);
      }
    },
    clearSession() {
      this.user = emptyUserData();
      this.setAuthorization("");
    },
    /** token 已过期则清掉本地登录态 */
    clearIfExpired(): boolean {
      if (!this.authorization || !this.exp) return false;
      const expSec = Number(this.exp);
      if (!Number.isFinite(expSec) || expSec <= 0) return false;
      if (expSec * 1000 > Date.now()) return false;
      this.clearSession();
      return true;
    },
    logout() {
      this.clearSession();
      ElNotification({
        title: "登出成功",
        message: "",
        type: "success",
        position: "top-right",
        duration: 3000,
        offset: 100
      });
    }
  }
});
